// Tab switching and arrows for sections/sivana-product-tabs.liquid. The arrows scroll the active tab's row.
class SivanaProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.arrows = [...this.querySelectorAll('.sivana-recs__arrow')];
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.select(tab));
      tab.addEventListener('keydown', (event) => this.onKey(event, tab));
    });
    this.arrows.forEach((arrow) => {
      arrow.addEventListener('click', () => {
        const track = this.activeTrack();
        if (!track) return;
        const card = track.querySelector('.sivana-recs__card');
        const step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap) : 300;
        const cards = Math.max(1, Math.floor(track.clientWidth / step) - 1);
        track.scrollBy({ left: Number(arrow.dataset.direction) * step * cards, behavior: 'smooth' });
      });
    });
    this.querySelectorAll('.sivana-recs__track').forEach((track) => {
      track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
    });
    window.addEventListener('resize', () => this.updateArrows(), { passive: true });
    this.updateArrows();
  }

  activeTrack() {
    return this.querySelector('.sivana-tabs__panel:not([hidden]) .sivana-recs__track');
  }

  updateArrows() {
    const track = this.activeTrack();
    if (!track) return;
    const max = track.scrollWidth - track.clientWidth - 2;
    this.arrows.forEach((arrow) => {
      arrow.disabled = arrow.dataset.direction === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max;
    });
  }

  select(tab) {
    this.tabs.forEach((other) => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      this.querySelector(`#${other.getAttribute('aria-controls')}`).hidden = !selected;
    });
    this.updateArrows();
  }

  onKey(event, tab) {
    if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
    const index = this.tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : -1);
    const next = this.tabs[(index + this.tabs.length) % this.tabs.length];
    next.focus();
    this.select(next);
  }
}

if (!customElements.get('sivana-product-tabs')) customElements.define('sivana-product-tabs', SivanaProductTabs);
